import React from 'react';
import classNames from 'clsx';
import { FormattedMessage } from 'react-intl';

import { Text } from 'ui-components/components/text';

import style from './funds-summary.module.less';
import { messages } from './messages';
import { SurchargeTooltip } from './surcharge-tooltip';
import { FormattedCurrency } from '../../components/formatted-currency';

/**
 * FundsSummary component for displaying Add Funds summary with fees, if any
 * @param {object} props
 * @param {number} props.baseAmount - Amount of funding requested
 * @param {number} props.totalWithFees - Total amount including fees
 * @param {number} props.creditCardProcessingFee - Amount of credit card processing fee
 * @param {number} props.creditCardProcessingFeePercentage - Percentage of credit card processing fee
 * @param {string} props.currencyCode - Currency code for formatting amounts
 * @param {string} [props.className] - Optional additional class name for styling
 * @returns {React.ReactElement}
 */
export const FundsSummary = ({
  baseAmount,
  totalWithFees,
  creditCardProcessingFee,
  creditCardProcessingFeePercentage,
  currencyCode,
  className,
}) => {
  return (
    <div className={classNames(style.container, className)}>
      {creditCardProcessingFee > 0 && (
        <>
          <Text value={<FormattedMessage {...messages.fundsLabel} />} />
          <FormattedCurrency currencyCode={currencyCode} value={baseAmount} wrappingElement='span' />
          <div className={style['surcharge-label']}>
            <Text value={<FormattedMessage {...messages.surchargeLabel} values={{ creditCardProcessingFeePercentage }} />} />
            <SurchargeTooltip creditCardProcessingFeePercentage={creditCardProcessingFeePercentage} />
          </div>
          <FormattedCurrency currencyCode={currencyCode} value={creditCardProcessingFee} wrappingElement='span' />
        </>
      )}
      <Text value={<FormattedMessage {...messages.totalChargeLabel} />} />
      <span className={style['total-amount']}>
        <FormattedCurrency currencyCode={currencyCode} value={totalWithFees} />
      </span>
    </div>
  );
};
